import React from 'react';
import { showAdditionalInfo } from './revisionEditor/OperationTemplates/commandMap';
import { LayoutOrientations } from '../../globals';
import Panel from '../layout/Panel';
import Spacer from '../layout/Spacer';
import Button from '../layout/Button';
import { HelpIcon } from '../Iconset';
import Dialog from '../layout/Dialog';

const style = {
	// border: "1px dashed gray",
	padding: "0.1rem 0.4rem",
	marginBottom: ".3rem",
	cursor: "move"
}

export default function RevisionItemDialog(props)
{
	const revisionItem = props.item; 

	function onSD()
	{
		if(props.onShutdown)
		{
			props.onShutdown();
		}
	}

	//render
	return (
		<Dialog 
			title={"Optimization - "+revisionItem.name}
			className={"revisionInfoDialogRoot"}
			data-name={"revision-info-dialog-root"}
			actions={[{ label: "Close" }]}
			onShutdown={onSD}
		>
			<Panel orientation={LayoutOrientations.Horizontal}>Optimization: {revisionItem.revision ? revisionItem.revision : "Initial Upload"}</Panel>
			<Panel orientation={LayoutOrientations.Horizontal}>Job ID: <label style={{ userSelect:'all', color:'yellow' }}>{revisionItem.id ? revisionItem.id : "Unknown"}</label></Panel>
			<Panel orientation={LayoutOrientations.Horizontal}>Root File: {revisionItem.rootFile ? revisionItem.rootFile : "-"}</Panel>
			<Panel orientation={LayoutOrientations.Horizontal}>Queue Date: {revisionItem.date}</Panel>
			{revisionItem.startDate ? <Panel orientation={LayoutOrientations.Horizontal}>Process Started: {revisionItem.startDate}</Panel> : <></>}
			{revisionItem.endDate ? <Panel orientation={LayoutOrientations.Horizontal}>Process Finished: {revisionItem.endDate}</Panel> : <></>}
			{revisionItem.error ? <Panel orientation={LayoutOrientations.Horizontal}>Error: {revisionItem.error}</Panel> : <></>}
			<Spacer size={{ y:"5px" }}/>
			{revisionItem.operations || revisionItem.defaultOperations  ? 
				<Panel orientation={LayoutOrientations.Horizontal}>
					{/* <Spacer size={{x:"9px"}}/> */}
					<Button 
						category={"Revision"}
						data-name={"revision-job-info"}
						label="Additional Info"
						iconRenderer={<HelpIcon scale={1}/>}
						onClick={(e)=>{showAdditionalInfo(revisionItem)}}
					/>
				</Panel>
				: <></>}
		</Dialog>
	)
}